

import React, { useState } from 'react';
import { View, StyleSheet, Button } from 'react-native';
import BtnCircle from '../components/buttons/BtnCircle';
import BtnRectangle from '../components/buttons/BtnRectangle';
// import { useNavigation } from '@react-navigation/native';
import { themePattern } from '../constants/pattern';
import { PropsStackModelNav } from '../types';
import * as WebBrowser from 'expo-web-browser';

const rotaInstructions:any = 'Instructions'
const rotaCredits:any = 'Credits'
const rotaShared:any = 'Shared'


const privacypolicy: any = "https://eic.ifsc.usp.br/app/privacypolicy/PoliticaPrivacidade_DiscoDeAminoacidos.pdf";


export default function ModalNav({ route, navigation }: PropsStackModelNav) {
  // const navigation = useNavigation();


  // Função Referencia
  let openHelp = () => {
    navigation.navigate(rotaInstructions) // open drawer
  };
  let openCredits = () => {
    navigation.navigate(rotaCredits) // open drawer

  };
  let openShared = () => {
    navigation.navigate(rotaShared) // open drawer
  };
  let openPrivacypolicy = () => {
    WebBrowser.openBrowserAsync(privacypolicy)
    
  };
    return (
      <View style={styles.Opcoes}>
       
        <View style= {styles.item}>
            <BtnRectangle
            icon={"question"}
            key={"ajuda"}
            name={"SOBRE A MÍDIA"}
            onPress ={() => openHelp()}            
            />
        </View>
        <View style= {styles.item}>
            <BtnRectangle
            icon={"group"}
            key={"creditos"}
            name={"CRÉDITO"}
            onPress ={() => openCredits()}            
            />
        </View>
        <View style= {styles.item}>
            <BtnRectangle
            icon={"share-alt"}
            key={"compartilhar"}
            name={"COMPARTILHAR"}
            onPress ={() => openShared()}            
            />
        </View>
        <View style= {styles.item}>
            <BtnRectangle
            icon={"ban"}
            key={"PRIVACIDADE"}
            name={"PRIVACIDADE"}
            onPress ={() => openPrivacypolicy()}            
            />
        </View>
      </View>
    );
  }
  

  const styles = StyleSheet.create({
    Opcoes: {
      backgroundColor:themePattern.mobile.white,
      borderColor: themePattern.mobile.black,
      borderStyle: 'solid',
      borderWidth: 2,
      borderRadius: 15,
      flex:1,
      padding: 45,
      margin: 15,
      alignItems: 'center',
      justifyContent: 'space-around'
    },
    item :{
      width: "100%"
    }
  });
  